// extracted by mini-css-extract-plugin
module.exports = {"container":"l37QkqKOgykM-JjftEG17g=="};